import Icon from './atomic/Icon'
import Link from 'next/link'
import Trans from './atomic/Trans'
import { useSelector } from 'react-redux'
import { getTipoStrumento } from '../utils'
import { sendGTMData } from '../utils/gtm'

const RegisterBox = ({ variant = 'articolo' }) => {
  const { utente } = useSelector((state) => state.utente)
  const { paginaCorrente } = useSelector((state) => state.paginaCorrente)

  const getLabelGTM = () => {
    let eventLabel = 'non_valorizzata'
    if (paginaCorrente?.item?.model_class === 'strumento') {
      eventLabel = getTipoStrumento(paginaCorrente.item).split(' ')[0]
      if (eventLabel == 'scheda') {
        eventLabel = 'scheda_didattica'
      }
    } else {
      if (paginaCorrente?.item?.tipologia) {
        eventLabel = paginaCorrente?.item?.tipologia
      } else if (paginaCorrente?.item?.model_class) {
        eventLabel = paginaCorrente?.item?.model_class
      }

      if (paginaCorrente?.autore) {
        eventLabel = 'autori'
      }
    }
    return eventLabel
  }

  const handleGTM = () => {
    sendGTMData({
      event: 'GAevent',
      eventID: '18',
      eventCategory: 'conversioni',
      eventAction: 'diventa_membro_io_plus',
      eventLabel: getLabelGTM(),
      moreInfo: paginaCorrente?.item?.titolo.toGTMFormat() || 'non_valorizzato',
    })
  }

  return (
    <div className={`register-box register-box--${variant}`}>
      <div className="register-box__content">
        <p className="register-box__title">
          <Trans chiave="Questo contenuto è riservato agli abbonati io+" />
        </p>
        <div className="register-box__side">
          <p className="register-box__description">
            {utente ? (
              <span>
                <Trans chiave="Vuoi unirti agli iscritti a io+ e godere degli stessi vantaggi?" />
              </span>
            ) : (
              <span>
                <Trans chiave="Vuoi provarlo gratis per un mese? Registrati a giuntiscuola.it." />
              </span>
            )}
          </p>
          <div className="register-box__cta-box">
            {utente ? (
              <a
                className="button button--primary button--orange button--inverted register-box__cta register-box__cta--abbonamento"
                href="/io-piu"
                onClick={() => handleGTM()}
              >
                <Trans chiave="Abbonati a io+" />
              </a>
            ) : (
              <Link legacyBehavior href="/registrazione">
                <a
                  className="button button--primary button--orange button--inverted register-box__cta register-box__cta--abbonamento"
                  onClick={() => handleGTM()}
                >
                  <Trans chiave="Provalo gratis" />
                </a>
              </Link>
            )}
            <Link legacyBehavior href="/io-piu">
              <a className="button button--secondary button--inverted register-box__cta register-box__cta--vantaggi">
                <Trans chiave="Scopri i vantaggi io+" />
              </a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterBox
